import { App } from 'vue';
import 'chart.js/auto';
import { Bar, Pie } from 'vue-chartjs';

import 'chartjs-adapter-luxon';

export default function (app: App) {
    app.component('BarChart', Bar);
    app.component('PieChart', Pie);
}
